import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function CircularLoading({ open, message = "Processing...", subtext, size = 80 }) {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1500,
        gap: 2,
        p: 2,
      }}
    >
      <CircularProgress size={size} sx={{ color: "#fff" }} />
      <Typography variant="h5" sx={{ color: "#fff", fontWeight: 600, textAlign: "center" }}>
        {message}
      </Typography>
      {subtext ? (
        <Typography
          variant="body2"
          sx={{ color: "rgba(255, 255, 255, 0.85)", textAlign: "center" }}
        >
          {subtext}
        </Typography>
      ) : null}
    </Box>
  );
}
